import {isNumber} from 'utils/IsNumber.js';
import React, { Component } from 'react';
import Sticky from 'react-sticky-el';
import {getParameters, autoCompleteParameter} from 'scripting/commands/effects.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {TAG} from 'constants/field-types.js';
import SequenceButtonsContainer from './bottomBar/SequenceButtonsContainer.js';
import AutoCompleteSuggestions from './bottomBar/AutoCompleteSuggestions.js';
import {nameToEffect} from 'effects/EffectsList.js';
import {nameToMidiEffect} from 'effects/midi/getMidiEffect.js';
import {nameToLiveEffect} from 'effects/live/getLiveEffect.js';
import ContextualHelpComponent from 'components/sidebar/ContextualHelpComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import { Input} from 'reactstrap';
import { connect } from "react-redux";
import {setCommandInput} from 'actions/index.js';
import {setViewMode} from 'actions/index.js';
import {setIsRecording} from 'actions/index.js';
import {setShowPianoRoll} from 'actions/index.js';
import {setContextualHelp} from 'actions/index.js';
import {setIsRecordingExpanded} from 'actions/index.js';
import {setCommandPrefix} from 'actions/index.js';
import {setQuantized} from 'actions/index.js';
import {setTrackRolling} from 'actions/index.js';
import {SCRIPTING_VIEW} from 'constants/view-modes.js';

import "../Script.scss";

class StickyScriptComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            focused: props.scriptingFocused,
            command: '',
            info: '',
            suggestions: [],
        };

        this.sequencerEngine = this.props.sequencerEngine;

        props.scripting.onFlashInfo = (info) => this.onFlashInfo(info);
    }

    shouldComponentUpdate(nextProps) {
        if (this.state.focused != nextProps.scriptingFocused &&
            nextProps.scriptingFocused) {
            this.input.focus();
        } 
        
        this.state.focused = nextProps.scriptingFocused;
        return true;
    }

    onFlashInfo(info) {
        this.setState({info: info});
        setTimeout(() => {
            this.setState({info: ''}); 
        }, 2000);
    }

    handleChange(e) {
        if (e.target.value === '') {
            this.setState({suggestions: []});
        }
        this.setState({command: e.target.value});
    }

    onKeyPress(e) {
        if (e.key === 'Enter') {
            if (this.props.scripting.runScript(this.state.command)) {
                this.props.update();
                this.setState({running: true});
                setTimeout(() => {
                    this.setState({running: false});
                    this.setState({command: '', suggestions: []});
                    this.input.blur();
                }, 100);
                this.props.setCommandPrefix(undefined);
            }
        } else if (e.key === 'ArrowUp') {
            this.setState({command: this.props.scripting.upHistory()});
        } else if (e.key === 'ArrowDown') {
            this.setState({command: this.props.scripting.downHistory()});
        } else if (e.key === 'Tab') {
            e.preventDefault();
            this.autoComplete();
            return false;
        }
    }

    async autoComplete() {
        console.log('auto complete called');
        if (this.state.command.startsWith('/')) {
            let text = this.state.command.slice(1);
            let terms = this.terms;
            text = terms[terms.length - 1];
            if (text === undefined) {
                return;
            }

            if (terms.length === 1) {
                let results = await this.props.sequencerEngine.searcher
                    .freeTextSearch(text);
                let tags = results[TAG].map(t => t.value);
                if (tags.length === 1) {
                    terms[terms.length - 1] = tags[0];
                    this.setState({suggestions: [], command: '/' + terms.join('+')});
                } else {
                    let longestCommonPrefix = this.getLongestCommonPrefix(tags);
                    this.setState({
                        suggestions: tags,
                    });
                    if (longestCommonPrefix) {
                        this.setState({
                            command: '/' + longestCommonPrefix
                        });
                    }
                }
            } else if (terms.length > 1) {
                this.searchForTags(terms);
            }
        } else if (this.state.command.startsWith('+')) {
            let {effectName, parameters} = getParameters(this.state.command.slice(1));
            if (!this.state.command.includes('[')) {
                let matchingEffects = Object.keys(nameToEffect)
                    .filter(n => n.toLowerCase().startsWith(effectName.toLowerCase()));
                let matchingMidiEffects = Object.keys(nameToMidiEffect)
                    .filter(n => n.toLowerCase().startsWith(effectName.toLowerCase()));
                let matchingLiveEffects = Object.keys(nameToLiveEffect)
                    .filter(n => n.toLowerCase().startsWith(effectName.toLowerCase()));
                matchingEffects = [... matchingEffects, ...matchingMidiEffects, ...matchingLiveEffects];
                if (matchingEffects.length === 1) {
                    this.setState({
                        command: '+' + matchingEffects[0]
                    });
                } else if (matchingEffects.length > 1) {
                    this.setState({
                        suggestions: matchingEffects
                    });
                }
            } else {
                let lastParameter = parameters.length === 0 ? '' :
                    parameters[parameters.length - 1].value === '' ?
                    parameters[parameters.length - 1].parameter :
                    '';

                let autoComplete = autoCompleteParameter(
                    this.props.sequencerEngine,
                    effectName,
                    lastParameter);

                if (autoComplete.length === 1) {
                    let command = '+' + effectName + '[';
                    let completedParameters = parameters.slice(
                        0,
                        parameters.length - 1);
                    command += completedParameters.map(
                        x =>
                            x.parameter + '=' + x.value).join(' ');
                    if (completedParameters.length > 0) {
                        command += ' ';
                    }
                    command += autoComplete[0];
                    this.setState({
                        suggestions: [],
                        command: command,
                    });
                    // add the auto completed result
                } else {
                    this.setState({
                        suggestions: autoComplete,
                    });
                }
            }
        }
    }

    // if you search 808+ and hit "tab", then auto-complete should
    // show all tags that are relevant to 808's. And if there
    // is only one suggestion, simply choose that
    async searchForTags(tags) {
        let tagsToSearch = tags.slice(0, tags.length - 1);
        let tagToSearch = tags[tags.length - 1];
        let searcher = this.props.sequencerEngine.searcher;
        searcher.selectedTags = tagsToSearch;
        let tagsFound = await searcher.getTopTags();
        searcher.selectedTags = [];

        tagsFound = tagsFound
            .map(x => x.value)
            .filter(x => x
                    .toLowerCase()
                    .includes(tagToSearch.toLowerCase()));

        if (tagsFound.length === 1) {
            this.setState({
                command: '/' + tagsToSearch.join('+') + '+' + tagsFound[0],
                suggestions: [],
            });
            return;
        }

        this.setState({
            suggestions: tagsFound,
        });

        if (tagsToSearch === '') {
            return;
        }
        let longestPrefix = this.getLongestCommonPrefix(tagsFound);
        if (longestPrefix) {
            this.setState({
                command: '/' + tagsToSearch.join('+') + '+' + longestPrefix
            });
        }
    }

    getLongestCommonPrefix(tags) {
        let longestPrefix = undefined;
        for (let i in tags) {
            if (longestPrefix === undefined) {
                longestPrefix = tags[i];
            } else {
                longestPrefix = this.getCommonPrefix(tags[i], longestPrefix);
                if (longestPrefix === undefined) {
                    return undefined;
                }
            }
        }

        return longestPrefix;
    }

    getCommonPrefix(a, b) {
        let prefix = '';
        for (let i=0; i < Math.min(a.length, b.length); i++) {
            if (a[i] === b[i]) {
                prefix += a[i];
            } else {
                break;
            }
        }

        return prefix === '' ? undefined : prefix;
    }

    get terms() {
        return this.state.command.slice(1).split('+');
    }

    setInput(input) {
        if (this.input === undefined) {
            this.input = input;
            this.props.onSetInput(input);
            this.props.setCommandInput(input);
        }
    }

    render() {
        let scriptClassName = "script-input";
        if (this.state.running) {
            scriptClassName += ' running';
        }

        return (
            <Sticky
              holderProps={{id: "bottom-holder"}}
              className="sticky-script-container" mode="bottom" boundaryElement=".scroll-area" hideOnBoundaryHit={false} bottomOffset={0}>
              <div className="bottom-toolbar">
                <div className="bottom-toolbar-left">
                  <ConditionedComponent condition={this.state.suggestions.length > 0}>
                    <AutoCompleteSuggestions suggestions={this.state.suggestions}/>
                  </ConditionedComponent>
                  <ConditionedComponent condition={this.state.suggestions.length === 0}>
                    <SequenceButtonsContainer sequencerEngine={this.props.sequencerEngine}/>
                  </ConditionedComponent>
                  <div className="clear-fix"/>
                  <div className="bar"/>
                  <div className="script-container">
                    <div className="command-label">
                      <ConditionedComponent condition={this.props.commandPrefix !== undefined}>
                        {this.props.commandPrefix}
                      </ConditionedComponent>
                      <ConditionedComponent condition={this.props.commandPrefix === undefined}>
                        &gt;
                      </ConditionedComponent>
                      </div>
                    <div className="command-container">
                      {this.state.info !== '' ? <div className="error-message">{this.state.info} </div>: 
                          <input
                                value={this.state.command} onChange={(e) => this.handleChange(e)} 
                                onKeyDown={(e) => this.onKeyPress(e)}
                                ref={(input) => { this.setInput(input)  }} 
                                className={scriptClassName} type="text"></input>
                          }
                    </div> 
                    <div className="sequence-name-container">
                      {this.props.sequenceName !== undefined ? this.props.sequenceName : ''}
                    </div>
                    <div
                      onClick={() => this.props.setShowPianoRoll(true)}
                      className="collapse-toggle bottom-shower">
                      <div className="arrow-left"></div>
                    </div>
                  </div>
                </div>
                <ContextualHelpComponent sequencerEngine={this.props.sequencerEngine}/>
              </div>
              </Sticky>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setViewMode: viewMode => dispatch(setViewMode(viewMode)),
        setShowPianoRoll: show => dispatch(setShowPianoRoll(show)),
        setQuantized: quantized => dispatch(setQuantized(quantized)),
        setContextualHelp: element => dispatch(setContextualHelp(element)),
        setIsRecording: recording => dispatch(setIsRecording(recording)),
        setTrackRolling: rolling => dispatch(setTrackRolling(rolling)),
        setCommandPrefix: prefix => dispatch(setCommandPrefix(prefix)),
        setIsRecordingExpanded: recording => dispatch(setIsRecordingExpanded(recording)),
        setCommandInput: input => dispatch(setCommandInput(input)),
    }
};
const mapStateToProps = (state, props) => {
    let id = state.sequencer.sequencerEngine.getSequenceId();
    return {
        sequencerEngine: state.sequencer.sequencerEngine,
        viewMode: state.sequencer.viewMode,
        quantized: state.sequencer.quantized,
        isRecording: state.sequencer.isRecording,
        isRecordingExpanded: state.sequencer.isRecordingExpanded,
        isPlaying: state.sequencer.isPlaying[id] || false,
        isCommandDown: state.keyboard.isCommandDown,
        sequenceName: state.sequencer.sequenceName,
        trackRolling: state.sequencer.trackRolling,
        patternLocked: state.sequencer.patternLocks[props.sequencerEngine.currentPattern] || false,
        playScheduled: state.clock.playScheduled,
        commandPrefix: state.commands.commandPrefix,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StickyScriptComponent);
